import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

import { v2Host } from '@/config/host';

export default {
  name: 'FileUpload',
  data: function data() {
    return {
      uploadFiles: [], // 待上传文件列表
      uploadResults: [], // 上传结果列表
      unzippedFiles: [], // 解压文件列表
      needUnzip: false, // 是否需要解压
      uploading: false // 是否正在上传
    };
  },

  computed: {
    uploadUrl: {
      get: function get() {
        return v2Host + '/upload/file';
      }
    }
  },
  methods: {
    handleFileChange: function handleFileChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.uploadFiles = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.uploadFiles = fileList;
    },
    beforeUpload: function beforeUpload(file) {
      // 这里可以添加文件类型、大小等限制
      var isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }
      return true;
    },
    submitUpload: function submitUpload() {
      var _this = this;

      if (this.uploadFiles.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }
      console.log(this.uploadFiles);
      this.uploading = true;
      // 为每个文件添加解压参数
      this.uploadFiles.forEach(function (file) {
        file.data = { unzip: _this.needUnzip ? 1 : 0, mod: 'files' };
      });
      // 触发上传组件的上传行为
      this.$refs.upload.submit();
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      var result = response.data;

      // 如果有解压文件，添加到解压文件列表
      if (result.files && result.files.length > 0) {
        var _unzippedFiles;

        this.uploadResults.push({
          name: result.origin_name,
          url: result.url + '.zip'
        });
        (_unzippedFiles = this.unzippedFiles).push.apply(_unzippedFiles, _toConsumableArray(result.files.map(function (file) {
          return {
            name: file,
            url: result.url + '/' + file
          };
        })));
      } else {
        this.uploadResults.push({
          name: result.origin_name,
          url: result.url
        });
      }

      // 如果所有文件都上传完成
      if (fileList.every(function (file) {
        return file.status === 'success';
      })) {
        this.$message.success('上传成功');
        this.uploadFiles = []; // 清空待上传列表
        this.uploading = false;
      }
    },
    handleError: function handleError(err, file, fileList) {
      this.$message.error('上传失败');
      console.error('Upload error:', err);
      this.uploading = false;
    },
    handleDownload: function handleDownload(file) {
      window.open(file.url);
    },
    handleCopy: function handleCopy(file) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var input;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(file.url);

              case 3:
                _this2.$message.success('链接已复制');
                _context.next = 14;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);
                input = document.createElement('input');

                input.value = file.url;
                document.body.appendChild(input);
                input.select();
                try {
                  document.execCommand('copy');
                  _this2.$message.success('链接已复制');
                } catch (err) {
                  _this2.$message.error('复制失败，请手动复制');
                }
                document.body.removeChild(input);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 6]]);
      }))();
    },
    handleDelete: function handleDelete(file) {
      var _this3 = this;

      this.$confirm('确认删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 这里添加删除文件的 API 调用
        _this3.$axios.delete('/api/upload/' + file.name).then(function () {
          _this3.uploadResults = _this3.uploadResults.filter(function (item) {
            return item !== file;
          });
          _this3.$message.success('删除成功');
        }).catch(function (error) {
          console.error('Delete error:', error);
          _this3.$message.error('删除失败');
        });
      }).catch(function () {
        _this3.$message.info('已取消删除');
      });
    },
    formatFileSize: function formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else if (size < 1024 * 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB';
      }
      return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
    }
  }
};